// extracted by mini-css-extract-plugin
export default {"itemContainer":"TotalItem_itemContainer__DzVfd","hours":"TotalItem_hours__dP2KN","item":"TotalItem_item__5I0DK"};